import { h, Component } from 'preact'
import { StoreContext } from './context'
import tdlib, { TdEvent } from '../../utils/tdlib'
import { iStore } from '../../types/store'

enum fieldTypes {
  users = 'users',
  lastMessages = 'lastMessages',
  chats = 'chats',
  groups = 'groups',
  statuses = 'statuses',
  pins = 'pins',
  unread = 'unread',
  chatActions = 'chatActions'
}

export const INITIAL_STATE = {
  [fieldTypes.users]: {},
  [fieldTypes.lastMessages]: {},
  [fieldTypes.chats]: {},
  [fieldTypes.groups]: {},
  [fieldTypes.statuses]: {},
  [fieldTypes.pins]: {},
  [fieldTypes.unread]: {},
  [fieldTypes.chatActions]: {},
}

export class StoreProvider extends Component<{}, iStore> {
  state = INITIAL_STATE

  componentDidMount (): void {
    tdlib.subscribe(
      'updateUser',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.users,
          'user'
        )
      }
    )

    tdlib.subscribe(
      'updateChatLastMessage',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.lastMessages,
          'last_message',
          'chat_id',
        )
      }
    )

    tdlib.subscribe(
      'updateNewChat',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.chats,
          'chat'
        )
      }
    )

    tdlib.subscribe(
      'updateSupergroup',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.groups,
          'supergroup'
        )
      }
    )

    tdlib.subscribe(
      'updateUserStatus',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.statuses,
          null,
          'user_id'
        )
      }
    )

    tdlib.subscribe(
      'updateChatIsPinned',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.pins,
          null,
          'chat_id'
        )
      }
    )

    tdlib.subscribe(
      'updateChatReadInbox',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.unread,
          null,
          'chat_id'
        )
      }
    )

    tdlib.subscribe(
      'updateUserChatAction',
      (event: TdEvent) => {
        this.setData(
          event,
          fieldTypes.chatActions,
          null,
          'chat_id'
        )
      }
    )
  }

  setData = (
    event: TdEvent,
    field: fieldTypes,
    source: string | null,
    id: string = 'id'
  ) => {
    const stateData = this.state[field] || {}
    const data = source
      ? event[source]
      : event

    this.setState({
      [field]: {
        ...stateData,
        [data[id]]: data
      }
    })
  }

  render () {
    const { children } = this.props

    return (
      <StoreContext.Provider value={this.state}>
        {children}
      </StoreContext.Provider>
    )
  }
}
